/* eslint-disable */

import store from '../store';
import i18next from "i18next";
import {HTTP_HYPER_ESPACE_BACKEND} from "@/services/http-common";
import { getFromSnake } from '@/helpers/functions/getFromSnake';

const CODES_BAILLEUR_SOCIAL = [
    '1000', '1100', '1111', '1112', '1113', '1114', '1115', '1116',
    '1131', '1132', '1133', '1134', '1135', '1136', '1137', '1138', '1139',
    '1190', '1192', '1193',
    '1200', '1210', '1211', '1212', '1213', '1214', '1215',
    '1220', '1222', '1223', '1224', '1225', '1226', '1227', '1229',
    '1230', '1232', '1233', '1235',
    '1240', '1241', '1248',
    '1260', '1262', '1263',
    '1290',
    '1300', '1310', '1320', '1330',
    '1351',
    '1360', '1370',
    '1390', '1393',
    '1400', '1410', '1411', '1412', '1420', '1421', '1422',
    '1500',
    '1900',
    '2000',
    '2200', '2209', '2212', '2213',
    '2290',
    '2300', '2313', '2320', '2330', '2331', '2333', '2342',
    '2390',
    '2400', '2410', '2420', '2421', '2422', '2423',
    '2430', '2431',
    '2490', '2491', '2493',
    '2900'
]

const CODES_ESPACIL = [
    '1000', '1100', '1111', '1115', '1116',
    '1132', '1133', '1134', '1135', '1136', '1137', '1138', '1139',
    '1190', '1192', '1193',
    '1200', '1210', '1211', '1229',
    '1400', '1410', '1411', '1412', '1420', '1421', '1422',
    '2000',
    '2390',
    '2400', '2410', '2420', '2430', '2431', '2490',
    '2900'
]

/**
 * Get the "definitionDonnee" of listed data
 * @param payload
 * @returns {Promise<*>}
 */
export async function getList(payload) {

    let params = {
        params: {
            codes: payload.fields.toString(),
        }
    };

    return HTTP_HYPER_ESPACE_BACKEND
        .get('/definition-donnee', params)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return {type: "error", message: error}
        })
}

/**
 * Get the offer types
 * @returns {Promise<*>}
 */
export async function getOfferTypes(){

    let sitimmoUser = store.getters.getSitimmoUser;

    let params = {
        params: {
            metier: sitimmoUser.metier,
            language: i18next.language
        }
    };

    return HTTP_HYPER_ESPACE_BACKEND
        .get('/v2/type-offre', params)
        .then(response => {
            store.commit('setOfferTypes', response.data);
            return response.data
        })
        .catch(error => {
            return {type: "error", message: error}
        })
}

/**
 * Get the objects types
 * @returns {Promise<*>}
 */
export async function getObjectTypes(annonceParente, annonceur = null, metier = null){

    let sitimmoUser = store.getters.getSitimmoUser;
    let codes = ''
    if (sitimmoUser.id == '353182') {
        metier = null
        codes = CODES_ESPACIL.join(',')
    } else if(!metier) {
        metier = sitimmoUser.metier;
    } else if (metier == 'BAILLEUR_SOCIAL') {
        metier = null
        codes = CODES_BAILLEUR_SOCIAL.join(',')
    }

    const queryParams = {
        metier: metier,
        annonceur: annonceur,
        codes: codes,
        language: i18next.language
    }
    // Ne passer annonce_parente que si définie : sinon l'API ne renvoie qu'un type parent
    // et les cascaders restent vides (hors contexte lot promoteur avec metier AGENCE).
    if (annonceParente) {
        queryParams.annonceParente = getFromSnake(queryParams, 'annonce_parente')
        queryParams.annonce_parente = annonceParente
    }

    return HTTP_HYPER_ESPACE_BACKEND
        .get('/v2/type-objet', { params: queryParams })
        .then(response => {
            return response.data
        })
        .catch(error => {
            return {type: "error", message: error}
        })
}

/**
 * Récupère un type d'objet par son code (affichage cascader en édition).
 */
export async function getObjectTypeById(typeObjetId) {
    return HTTP_HYPER_ESPACE_BACKEND
        .get(`/v2/type-objet/${typeObjetId}`)
        .then(response => response.data)
        .catch(error => ({ type: 'error', message: error }))
}
